/**
 * Created by rhinov15 on 17/01/2017.
 *
 * This is the node that display the background imported map if the user wants to draw on top of it
 */
import { Events, eventsManager } from "@rhinov/savane-js";
import { PlanManager } from "../../../../cocosPlan";


declare var cc: any;


export class UserMapNode extends cc.Sprite {
    constructor() {
        // Call parent constructor
        super()
        // Stores the path to the texture image to display
        this.path = null;
        // Keep the image textures in memory
        this.textures = [];
        // Canvas where to display the sprite
        this.canvas = [];
        // Scale of the sprite
        this.realScale = 1.0;
        this.selectedIndex = 0;
    }

     // Will cause the image texture to be loaded and displayed
    initUserMap(path: string, scale: number) {
        // Save the texture image path
        this.path = path;
        // Let's start with an empty texture image array
        this.textures = [];
        // and with no canvas
        this.canvas = [];
        // Load the texture image
        var texture = cc.textureCache.addImage(path);
        // Save the scale to apply
        this.realScale = scale;

        // Listen to when the texture will be loaded
        texture.addEventListener('load', function(this: UserMapNode) {
            // Save the loaded image into the image texture array
            this.textures.push(texture);
            // Create downscaled texture
            // Wait texture to be loaded
            // FIXME This solution is temporary workaround for really big pictures (like commercial center)
            // If this solution is choosen a benchmark may be needed to have accurate pixel number when a mimap solution is needed
            var intervalId = setInterval(function(this: UserMapNode) {
                // If the texture is loaded (otherwise we will can this again in 100ms)
                if (this._textureLoaded) {
                    // Stop the timer that calls this code every 100ms
                    clearInterval(intervalId);
                    // If the image is too big
                    if (this.texture.getContentSize().width * this.realScale > (window.screen.width / window.devicePixelRatio)) {
                        // Create downscaled version
                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d')!;

                        canvas.width = this.texture.getContentSize().width / UserMapNode.SCALE_RATE;
                        canvas.height = this.texture.getContentSize().height / UserMapNode.SCALE_RATE;

                        ctx.drawImage(this.texture._htmlElementObj, 0, 0, this.texture.getContentSize().width / UserMapNode.SCALE_RATE, this.texture.getContentSize().height / UserMapNode.SCALE_RATE);
                        try {
                            this.textures.push(cc.textureCache.addImage(canvas.toDataURL()));
                        } catch {}
                    }
                }
            }.bind(this), 200);
            //Save Scale
            this.setTexture(this.textures[0]);
            this.setScale(scale);
            this.setVisible(PlanManager.getInstance().mustShowPlan);
        }.bind(this), this);
    }

    // When the object is created
    onEnter() {
        // Call the object super class
        super.onEnter();
        // Attach listener for zoom update to avoid scaling with parent
        this.zoomListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, function(this: UserMapNode, event: any) {
            // TODO handle some zoom level to change mimap DIRTY may be optimized if this solution is validate
            // For now see initUserMap to view case where it's activated
            if (this.textures.length > 1) {
                // Select downscaled version of the image
                if (event.userData < 0.25 && this.selectedIndex !== 1) {
                    this.selectedIndex = 1;
                    this.setTexture(this.textures[1]);
                    this.setScale(this.realScale * UserMapNode.SCALE_RATE);
                }
                else {
                    // Select normal version of the image
                    if (event.userData >= 0.25 && this.selectedIndex !== 0) {
                        this.selectedIndex = 0;
                        this.setTexture(this.textures[0]);
                        this.setScale(this.realScale);
                    }
                }
            }
        }.bind(this));

        // Hide/Display area surface (button in the floating bar)
        this.dispPlan = eventsManager.instance.addListener(Events.TOGGLE_PLAN, function(this: UserMapNode, event: any) {
            this.setVisible(event.getUserData());
        }.bind(this));
    }

    // Call when the object is destroyed
    onExit() {
        // clear current cache
        for (var i = 0; i < this.textures.length; ++i) {
            cc.textureCache.removeTexture(this.textures[i]);
        }
        // Call parent class
        super.onExit();
        // Remove attached listener
        this.removeListeners();
    }

    // This will remove the attached listener
    removeListeners() {
        eventsManager.instance.removeListener(this.zoomListener);
        eventsManager.instance.removeListener(this.dispPlan);
    }
}

//CONSTANTS
UserMapNode.SCALE_RATE = 2.0;
